import TextField from "@mui/material/TextField";
import updChar from "../../_sig_api/updChar";
import {s_char} from "../../_signals/s_char";
import {Item} from "../CharStyled";
import React from "react";

export default function KarmaMaxNSC() {
    return <Item>
        <div>Max. Karma</div>
        <TextField InputLabelProps={{shrink: true}}
                   onChange={e => updChar([{k:'karma',v:parseInt(e.target.value)}])}
                   style={{marginLeft: 8, maxWidth: 80}}
                   value={s_char.value.karma}
                   variant="standard" type="number"/>
    </Item>
}